import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React from "react";
import { doesPermissionExist } from "../pages/util";

interface Props {
  label: string;
  value: string;
  permission?: string;
  width?: number;
}

export default function ShowAttr({
  label,
  value,
  width = 2,
  permission = "",
}: Props) {
  if (permission === "" || doesPermissionExist(permission)) {
    return (
      <Grid item xs={width}>
        <Typography variant="body1" gutterBottom>
          {label}: <b>{value}</b>
        </Typography>
      </Grid>
    );
  }
  return <></>;
}

export function ShowAttr2({ label, value, width = 2, permission = "" }: Props) {
  if (permission === "" || doesPermissionExist(permission)) {
    return (
      <Typography variant="body1" gutterBottom>
        {label}: <b>{value}</b>
      </Typography>
    );
  }
  return <></>;
}
